import WarningIcon from "@/public/assets/icons/warning-circle.svg"
import Link from "@/src/common/components/Link"
import classNames from "classnames"
import Image from "next/image"
import { ReactNode } from "react"

import Typography from "../Typography"

type TitleProps = {
  text: string
}

type RelatedFormSection = {
  text: string
  href: string
  linkLabel: string
}

type MarketingSectionProps = {
  text: string
}

const Title = (props: TitleProps) => (
  <div className="text-stears_black mb-2 dark:text-stears_white">
    <Typography type="p_14" fontWeight="bold">
      {props.text}
    </Typography>
  </div>
)
const RelatedFormSection = (props: RelatedFormSection) => {
  return (
    <div className="text-stears_black flex items-center justify-center dark:text-stears_white">
      <Typography type="p_12">{props.text}</Typography>
      <Link legacyBehavior href={props.href}>
        <a className="inline-block ml-1 text-p_12 text-accent-600 hover:underline force-as-internal-link">
          {props.linkLabel}
        </a>
      </Link>
    </div>
  )
}

const GoogleAuthNudge = (props: MarketingSectionProps) => {
  return (
    <div className="mt-7 mb-5">
      <Typography type="p_12">{props.text}</Typography>
    </div>
  )
}

const LineBreaker = () => (
  <div className="flex items-center mt-5 mb-3">
    <div className="flex items-center flex-1">
      <div className="dark:border-b-[0.5px] dark:border-[#4B5563] w-full"></div>
    </div>
    <p className="mx-[23px] text-xs text-gray-800 dark:text-[#4B5563]">OR</p>
    <div className="flex-1 flex items-center">
      <div className="dark:border-b-[0.5px] dark:border-[#4B5563] w-full"></div>
    </div>
  </div>
)

type FormItemProps = {
  children: ReactNode
  labelText: ReactNode
  labelHTMLFor: string
  labelExtraClassName?: string
}
const FormItem = (props: FormItemProps) => {
  const { children, labelText, labelHTMLFor, labelExtraClassName } = props
  return (
    <div className="mb-4">
      {labelText && (
        <label
          htmlFor={labelHTMLFor}
          className={classNames(
            "text-gray-800 block mb-2 text-xs font-light dark:text-[#9CA3AF]",
            labelExtraClassName
          )}
        >
          {labelText}
        </label>
      )}

      {children}
    </div>
  )
}

type FormErrorProps = {
  children: ReactNode
}
const FormError = (props: FormErrorProps) => {
  const { children } = props
  return (
    <div
      id="auth-form-error"
      className="w-100 font-jakarta text-xs bg-red-50 p-4 text-red-800 font-regular mt-7 tablet:w-full dark:bg-[#1A1D21] dark:text-[#F05042] dark:p-2 flex items-center space-x-2.5"
    >
      <Image
        src={WarningIcon}
        height={16}
        width={16}
        alt="Up arrow"
        className="transition-transform"
      />
      <div>{children}</div>
    </div>
  )
}

const AuthForm = {
  Title,
  RelatedFormSection,
  GoogleAuthNudge,
  LineBreaker,
  FormItem,
  FormError
}

export default AuthForm

/*
- give rectangle a radius
- forgot password should be underlined on hover
ƒ
*/
